import { aboutThemes } from '@/mocks/about';

export default function ThemesSection() {
  return (
    <section className="w-full py-10 md:py-20 bg-background-300 relative overflow-hidden scroll-mt-20">
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <div className="w-12 h-12 flex items-center justify-center absolute top-10 left-[6%] opacity-[0.05] rotate-[-15deg] animate-float">
          <i className="fa-solid fa-heart text-4xl text-foreground-950"></i>
        </div>
        <div className="w-14 h-14 flex items-center justify-center absolute top-16 right-[8%] opacity-[0.04] rotate-[20deg] animate-drift" style={{ animationDelay: '1s' }}>
          <i className="fa-solid fa-star text-5xl text-foreground-950"></i>
        </div>
        <div className="w-10 h-10 flex items-center justify-center absolute bottom-16 left-[10%] opacity-[0.05] rotate-[25deg] animate-drift" style={{ animationDelay: '2s' }}>
          <i className="fa-solid fa-heart text-3xl text-foreground-950"></i>
        </div>
        <div className="w-12 h-12 flex items-center justify-center absolute bottom-20 right-[12%] opacity-[0.04] rotate-[-30deg] animate-float" style={{ animationDelay: '3s' }}>
          <i className="fa-solid fa-star text-4xl text-foreground-950"></i>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
        <h2 className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3">Themes & Values We Celebrate</h2>
        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-12 max-w-3xl mx-auto">
          Gracie & Lily stories are designed to entertain children while encouraging imagination and
          positive values.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {aboutThemes.map((theme) => (
            <div
              key={theme.name}
              className="bg-white/60 rounded-2xl p-4 md:p-5 flex flex-col items-center gap-2 text-center hover:scale-[1.04] transition-transform duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className={`fa-solid ${theme.icon} text-lg`}></i>
              </div>
              <span className="text-sm md:text-base font-bold text-foreground-900">{theme.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}